import { useReducedMotion } from 'framer-motion';

// Animation variants for page transitions
export const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -20,
  },
};

// Transition configuration
export const pageTransition = {
  type: 'tween',
  ease: 'easeInOut',
  duration: 0.3,
};

// Slide variants (for specific use cases)
export const slideVariants = {
  initial: (direction = 1) => ({
    opacity: 0,
    x: direction > 0 ? 100 : -100,
  }),
  animate: {
    opacity: 1,
    x: 0,
  },
  exit: (direction = 1) => ({
    opacity: 0,
    x: direction > 0 ? -100 : 100,
  }),
};

// Fade only variants (minimal animation)
export const fadeVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

// Reduced motion variants (accessibility)
export const reducedMotionVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

// Hook to get appropriate variants based on user preference
export const usePageTransition = () => {
  const shouldReduceMotion = useReducedMotion();
  
  return {
    variants: shouldReduceMotion ? reducedMotionVariants : pageVariants,
    transition: shouldReduceMotion ? { duration: 0.15 } : pageTransition,
  };
};

// AnimatePresence configuration
export const animatePresenceConfig = {
  mode: 'wait',
  initial: false,
};
